export const FONTS = [
  'Press Start 2P',
  'Roboto:400,700',
  'Orbitron:400,700', 
  'Noto Sans JP:400,700',
  'Quicksand:400,500,700',
  'Montserrat:400,700,800',
  'Poppins:400,500,600',
  'Cormorant Garamond:400,500,600',
  'Noto Serif JP:500',
  'Playfair Display:400,500,600,700',
  'Inter:400,500,600',
  'Source Sans Pro:400,600',
  'Lato:400,700',
  'Cormorant Unicase:400,600'
]
